sessionStorage.removeItem( 'aldcqMakeId' );
sessionStorage.removeItem( 'aldcqModelId' );
sessionStorage.removeItem( 'aldcqFuelId' );
sessionStorage.removeItem( 'ecocar' );
sessionStorage.removeItem( 'fwd' );
sessionStorage.removeItem( 'sale' );

var $ = jQuery;

function getJson() {
    return JSON.parse( atob( sessionStorage.getItem( 'aldcqData' ) ) );
}

var makesSelect = $( '#quickMake' );
var modelsSelect = $( '#quickModel' );
var visaButton = $( '#quickVisa' );

function buildMakesList() {
    var json = getJson();
    var list = json.list;
    var makesOptions = [];
    makesOptions.push( '<option value="-2" selected="selected" disabled>' + mycelic_js_translate.select_make + '</option>' );
    makesOptions.push( '<option value="-1">' + mycelic_js_translate.all_makes + '</option>' );
    list.forEach( function( make ) {
        var makeOption = '<option value="' + make.make_id + '">' + make.make + '</option>';
        makesOptions.push( makeOption );
    });
    makesSelect.html( makesOptions.join('') );

    $( makesSelect ).SumoSelect({
        placeholder: false,
        isClickAwayOk: true,
        forceCustomRendering: true,
        floatWidth: 1
    });

    $(makesSelect)[0].sumo.reload();

    $( '.SumoSelect' ).show( function () {
        $('#quickMakeFake').remove();
    });

    var makeId = makesSelect.val();
    buildModelsList( makeId );

    $( visaButton ).text( mycelic_js_translate.go_further ).prop( 'disabled', false );
}

function buildModelsList(id) {
    var modelsArr = [];
    var selected = [];
    var json = getJson();
    var list = json.list;

    if ( ! id ) {
        var optgroup = [];
        optgroup.push( '<option value="-2" selected="selected" disabled>' + mycelic_js_translate.select_make_first + '</option>' );
        modelsArr.push( optgroup.join('') );
        // console.log( id );
    } else if ( id > -1 ) {
        var arr = $.grep( list, function( el, idx ) {
            return el.make_id === id;
        });
        selected.push( arr[0] );
        selected.forEach( function( element ) {
            var optgroup = [];
            var models = element.models;
            optgroup.push( '<option value="-2" selected="selected" disabled>' + mycelic_js_translate.select_model + '</option>' );
            optgroup.push( '<option value="-1">' + mycelic_js_translate.all_models + '</option>' );
            models.forEach( function( model ) {
                for ( var id in model ) {
                    optgroup.push( '<option value="' + id + '">' + model[id] + '</option>' );
                }
            });
            modelsArr.push( optgroup.join('') );
        });
    } else {
        var optgroup = [];
        optgroup.push( '<option value="-1" selected="selected">' + mycelic_js_translate.all_models + '</option>' );
        modelsArr.push( optgroup.join('') );
    }

    modelsSelect.html( modelsArr.join('') );

    $( modelsSelect ).SumoSelect({
        placeholder: false,
        isClickAwayOk: true,
        forceCustomRendering: true,
        floatWidth: 1
    });

    modelsSelect[0].sumo.reload();

    $( '.SumoSelect' ).show( function () {
        $('#quickModelFake').remove();
    });
}

var checkChache = function() {
    var aldcqSessionsCache = sessionStorage.getItem( 'aldcqData' );

    if ( aldcqSessionsCache && aldcqSessionsCache.length ) {
        localStorage.setItem( 'aldcqData', aldcqSessionsCache );
        return true;
    } else {
        if ( localStorage.getItem( 'aldcqData' ) ) {
            localStorage.removeItem( 'aldcqData' );
        }
        return false;
    }
};

function doAjax() {
    try {
        return $.ajax({
            type: 'GET',
            url: bilportlenAjax.ajaxUrl,
            data: { 'action': 'getCars', 'cid': customerId, 'pid': policyId },
            dataType: 'json'
        })
    } catch (e) {
        console.log(e);
    }
}

$(document).ready( function() {
    if ( "ERROR" === sessionStorage.getItem( 'aldcqData' ) ) {
        sessionStorage.removeItem( 'aldcqData' );
    }
    // console.log( 'frontpage' );
    if ( ! checkChache() ) {
        doAjax().done( function( response ) {
            // sessionStorage.removeItem( 'aldcqData' );
            // sessionStorage.setItem( 'aldcqData', response.data );
            // localStorage.setItem( 'aldcqData', response.data );
            //
            // var json = getJson();

            if ( "ERROR" === response.status ) {
                window.location = '/404';
            }

            if ( "OK" === response.status ) {
                if ( sessionStorage.getItem( 'aldcqData' ) ) {
                    sessionStorage.removeItem( 'aldcqData' );
                }
            }

            sessionStorage.setItem( 'aldcqData', response.data.json );
            json = $.parseJSON( atob( sessionStorage.getItem( 'aldcqData' ), true ) );

            buildMakesList( json );
        }).fail( function() {
            console.log( "AJAX Call error!" );
        })
    } else {
        var json = getJson();
        buildMakesList( json );
    }

    makesSelect.on( 'change', function() {
        var id = this.value;
        buildModelsList( id );
    });

    visaButton.on( 'click', function(e) {
        e.preventDefault();

        if ( $( this ).is( 'disabled' )  ) {
            return false;
        }

        var makeId = makesSelect.val();
        var modelId = modelsSelect.val();

        if ( makeId === null || !makeId ) {
            makeId = null;
        }

        if ( modelId === null || !modelId ) {
            modelId = null;
        }

        sessionStorage.setItem( 'aldcqMakeId', makeId );
        sessionStorage.setItem( 'aldcqModelId', modelId );
        window.location = '/cars';
    });

    // $( '#bilmarken' ).slick({
    //     mobileFirst: true,
    //     slidesToShow: 4,
    //     slidesToScroll: 1,
    //     prevArrow: prevArrow,
    //     nextArrow: nextArrow,
    //     autoplay: true,
    //     dots: false,
    //     autoplaySpeed: 3000,
    //     responsive: [
    //         {
    //             breakpoint: 1050,
    //             settings: {
    //                 slidesToShow: 4,
    //                 slidesToScroll: 1,
    //             }
    //         },
    //         {
    //             breakpoint: 960,
    //             settings: {
    //                 slidesToShow: 4,
    //                 slidesToScroll: 1,
    //                 arrows: false
    //             }
    //         },
    //         {
    //             breakpoint: 768,
    //             settings: {
    //                 slidesToShow: 3,
    //                 slidesToScroll: 1,
    //                 arrows: false
    //             }
    //         },
    //         {
    //             breakpoint: 480,
    //             settings: {
    //                 slidesToShow: 1,
    //                 slidesToScroll: 1,
    //                 arrows: false
    //             }
    //         },
    //         {
    //             breakpoint: 320,
    //             settings: {
    //                 slidesToShow: 1,
    //                 slidesToScroll: 1,
    //                 arrows: false
    //             }
    //         },
    //         {
    //             breakpoint: 10,
    //             settings: {
    //                 slidesToShow: 1,
    //                 slidesToScroll: 1,
    //                 arrows: false
    //             }
    //         }
    //     ]
    // });
    //
    // $( '#bilmarken' ).css( 'opacity', 1 );

    // var $carElements    = $('#bilmarken > li:gt(3)'),
    //     $moreBtn        = $('.view-more'),
    //     $moreBtnText    = $('.view-more > span > p'),
    //     $moreBtnUp      = $('.view-more > span > img.arrow-up'),
    //     $moreBtnDown    = $('.view-more > span > img.arrow-down');
    //
    // $carElements.hide();
    // $moreBtnUp.hide();
    //
    // $moreBtn.click(function(event) {
    //     event.preventDefault();
    //     event.stopPropagation();
    //     $carElements.slideToggle();
    //     $($moreBtnText).text( $($moreBtnText).text() == 'Visa fler bilmärken' ? 'Visa färre bilmärken' : "Visa fler bilmärken");
    //     $('.view-more').find('.arrow-up, .arrow-down').toggle();
    // });
});

